<app-cx-brand-color-bar></app-cx-brand-color-bar>


<section class="alert">
  <section *ngIf="visibilitySuccsessAlert">
    <app-cx-alerts
      messageText="{{ messageSuccsessAlert }}"
      type="success"
    ></app-cx-alerts>
  </section>
  <section *ngIf="visibilityWarnAlert">
    <app-cx-alerts
      messageText="{{ messageWarnAlert }}"
      type="warn"
    ></app-cx-alerts>
  </section>
  <section *ngIf="visibilityInfoAlert">
    <app-cx-alerts
      messageText="{{ messageInfoAlert }}"
      type="info"
    ></app-cx-alerts>
  </section>
</section>
<router-outlet></router-outlet>
